









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import RefreshIcon from 'vue-material-design-icons/Refresh.vue';

@Component({
	components: {
		RefreshIcon
	}
})
export default class BrowserUrlBar extends Vue {
	@Prop() public currentUrl!: string;

	public url: string = '';

	@Watch('currentUrl', { immediate: true })
	public handleUrlChange(value: string) {
		this.url = value;
	}

	public urlChanged(url: string) {
		this.$emit('urlChanged', url);
	}

	public refreshButtonClicked() {
		this.$emit('refreshClicked');
	}
}
